import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import Navbar from './Navbar';
import Footer from '../../components/Footer';
import Hero from './Hero';
import Features from './Features';
import Download from './Download';
import SocialProof from './SocialProof';
import Pricing from './Pricing';
import theme from '../../theme';
import MaxWidthContainer from '../../components/MaxWidthContainer';
import _ from 'lodash';
import StripesHighlight from './StripesHighlight';
import { getSections } from '../../utils';

/* -- STYLED ELEMENTS -- */

const LandingPageContainer = styled.div`
  width: 100%;
  height: 100vh;
  overflow-y: scroll; /* has to be scroll, not auto */
  -webkit-overflow-scrolling: touch; /* For smooth scrolling in iOS */
  padding-top: ${theme.ptNavbarHeight};
`;

const Body = styled.div``;

const Section = styled.div`
  padding: ${theme.navbarHeight} 0;
  height: ${props => props.height ? props.height : '100%'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const HighlightContainer = styled.div`
  background: ${theme.highlightColor};
`;

const SolidHighlight = styled.div`
  background: ${theme.highlightColor}; /* Old browsers */
  background: -moz-linear-gradient(top, ${theme.highlightColor}, white 45%);
  background: -webkit-linear-gradient(top, ${theme.highlightColor}, white 45%);
  background: linear-gradient(to bottom, ${theme.highlightColor}, white 45%);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const BlankSpace = styled.div`
  width: 100%;
  height: 80px
`;

const Title = styled.h2`
  margin: 30px 0;
  text-align: center;
`;


/* --- SECTIONS --- */

const SECTIONS = getSections();

const HeroSection = () => SECTIONS.hero ? (
    <Section id={SECTIONS.hero}>
      <MaxWidthContainer>
        <Hero />
      </MaxWidthContainer>
    </Section>
  ) : null;

const FeaturesSection = () => SECTIONS.features ? (
    <Section id={SECTIONS.features}>
      <MaxWidthContainer>
        <Title>Features</Title>
        <Features />
      </MaxWidthContainer>
    </Section>
  ) : null;

const SocialProofSection = () => SECTIONS.socialProof ? (
    <Section id={SECTIONS.socialProof}>
      <MaxWidthContainer>
        <Title>Stories from our Users</Title>
        <SocialProof/>
      </MaxWidthContainer>
    </Section>
  ) : null;


const DownloadSection = () => SECTIONS.download ? (
    <Section id={SECTIONS.download}>
      <MaxWidthContainer>
        <Title>Download</Title>
        <Download/>
      </MaxWidthContainer>
    </Section>
  ) : null;

const PricingSection = () => SECTIONS.pricing ? (
    <Section id={SECTIONS.pricing}>
      <MaxWidthContainer>
        <Title>Pricing</Title>
        <Pricing />
      </MaxWidthContainer>
    </Section>
  ) : null;

/* --- SITE -- */

class PublicWebsite extends React.Component {

  state = {scrolled: false};

  handleScroll = (e) => {
    const scrollTop = _.get(e, 'target.scrollTop', -1);
    const scrolled = scrollTop > 0;
    this.setState({scrolled})
  };

  componentDidMount() {
    // Listen if scrolled from top
    const containerNode = ReactDOM.findDOMNode(this.ref);
    if (containerNode) {
      containerNode.addEventListener('scroll', this.handleScroll);
    }
  }

  componentWillUnmount() {
    // Remove scroll listener
    const containerNode = ReactDOM.findDOMNode(this.ref);
    if (containerNode) {
      containerNode.removeEventListener('scroll', this.handleScroll);
    }
  }

  render() {

    return (
      <LandingPageContainer ref={ref => this.ref = ref}>
        <Navbar showBorder={this.state.scrolled}/>
        <Body>
        <HeroSection/>

        <HighlightContainer>
          <StripesHighlight width="100%" height="150px" />
          <SolidHighlight>
            <FeaturesSection/>
          </SolidHighlight>
        </HighlightContainer>

        <SocialProofSection/>
        <DownloadSection/>

        <HighlightContainer>
          <StripesHighlight width="100%" height="150px" flipped/>
          <SolidHighlight>
            <PricingSection/>
          </SolidHighlight>
        </HighlightContainer>

        <BlankSpace/>

        </Body>
        <Footer/>
      </LandingPageContainer>
    )
  }
}

export { SECTIONS };
export default PublicWebsite;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/index.js